<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.isKeepLive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.isKeepLive"/>
    <!-- <updatePage /> -->
  </div>
</template>
<script>
import updatePage from './views/update_page.vue';
export default {
  components: {
    updatePage
  },
  watch: {
    $route (val) {
      document.title = val.name
    }
  }
}
</script>
<style lang="less">
</style>
